import { __extends, __assign, __rest, __makeTemplateObject } from 'tslib';
import React, { Component, forwardRef } from 'react';
import { styled } from 'styled-components';
import classnames from 'classnames';
import { SuomifiThemeConsumer } from '../../../../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../../../../theme/SuomifiTheme/SuomifiTheme.js';
import { SpacingConsumer } from '../../../../theme/SpacingProvider/SpacingProvider.js';
import { separateMarginProps } from '../../../../theme/utils/spacing.js';
import '../../../../../reset/HtmlA/HtmlA.js';
import '../../../../../reset/HtmlButton/HtmlButton.js';
import { HtmlDiv } from '../../../../../reset/HtmlDiv/HtmlDiv.js';
import '../../../../../reset/HtmlFieldSet/HtmlFieldSet.js';
import '../../../../../reset/HtmlH/HtmlH.js';
import '../../../../../reset/HtmlInput/HtmlInput.js';
import '../../../../../reset/HtmlLabel/HtmlLabel.js';
import '../../../../../reset/HtmlLegend/HtmlLegend.js';
import '../../../../../reset/HtmlLi/HtmlLi.js';
import '../../../../../reset/HtmlNav/HtmlNav.js';
import '../../../../../reset/HtmlOl/HtmlOl.js';
import '../../../../../reset/HtmlSpan/HtmlSpan.js';
import '../../../../../reset/HtmlTextarea/HtmlTextarea.js';
import '../../../../../reset/HtmlUl/HtmlUl.js';
import '../../../../../reset/HtmlTable/HtmlTable.js';
import '../../../../../reset/HtmlTable/HtmlTableCaption.js';
import '../../../../../reset/HtmlTable/HtmlTableHeader.js';
import '../../../../../reset/HtmlTable/HtmlTableRow.js';
import '../../../../../reset/HtmlTable/HtmlTableBody.js';
import '../../../../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../../../../reset/HtmlTable/HtmlTableCell.js';
import { getOwnerDocument, filterDuplicateKeys } from '../../../../../utils/common/common.js';
import { AutoId } from '../../../../utils/AutoId/AutoId.js';
import { Debounce } from '../../../../utils/Debounce/Debounce.js';
import { Popover, PopoverConsumer } from '../../../../Popover/Popover.js';
import { FilterInput } from '../../../FilterInput/FilterInput.js';
import { SelectItemList } from '../../BaseSelect/SelectItemList/SelectItemList.js';
import { SelectItem } from '../../BaseSelect/SelectItem/SelectItem.js';
import { SelectEmptyItem } from '../../BaseSelect/SelectEmptyItem/SelectEmptyItem.js';
import { VisuallyHidden } from '../../../../VisuallyHidden/VisuallyHidden.js';
import { MultiSelectChipList } from '../MultiSelectChipList/MultiSelectChipList.js';
import { MultiSelectRemoveAllButton } from '../MultiSelectRemoveAllButton/MultiSelectRemoveAllButton.js';
import { baseStyles } from './MultiSelect.baseStyles.js';
import { InputToggleButton } from '../../../InputToggleButton/InputToggleButton.js';
import { SelectItemAddition } from '../../BaseSelect/SelectItemAddition/SelectItemAddition.js';
import { LoadingSpinner } from '../../../../LoadingSpinner/LoadingSpinner.js';

var baseClassName = 'fi-multiselect';
var multiSelectClassNames = {
  open: "".concat(baseClassName, "--open"),
  error: "".concat(baseClassName, "--error"),
  fullWidth: "".concat(baseClassName, "--full-width"),
  content_wrapper: "".concat(baseClassName, "_content_wrapper"),
  removeAllButton: "".concat(baseClassName, "_removeAllButton")
};
var BaseMultiSelect = function (_super) {
  __extends(BaseMultiSelect, _super);
  function BaseMultiSelect(props) {
    var _this = _super.call(this, props) || this;
    _this.chipRemovalAnnounceTimeOut = null;
    _this.state = {
      filterInputValue: '',
      filteredItems: _this.props.items,
      showPopover: false,
      showOptionsAvailableText: false,
      focusedDescendantId: null,
      selectedItems: _this.props.selectedItems ? _this.props.selectedItems || [] : _this.props.defaultSelectedItems || [],
      chipRemovalAnnounceText: '',
      computedItems: _this.props.items
    };
    _this.handleItemSelection = function (item) {
      if (item.disabled) return;
      var _a = _this.props,
        onItemSelectionsChange = _a.onItemSelectionsChange,
        onItemSelect = _a.onItemSelect,
        controlledItems = _a.selectedItems;
      var newSelectedItems = [];
      if (_this.state.selectedItems.find(function (prevItem) {
        return prevItem.uniqueItemId === item.uniqueItemId;
      })) {
        newSelectedItems = _this.state.selectedItems.filter(function (selectedItem) {
          return selectedItem.uniqueItemId !== item.uniqueItemId;
        });
      } else {
        newSelectedItems = _this.state.selectedItems.concat([item]);
      }
      if (!controlledItems) {
        _this.setState(function (prevState, prevProps) {
          var itemIsFromPropItems = prevProps.items.some(function (propItem) {
            return propItem.uniqueItemId === item.uniqueItemId;
          });
          if (prevState.selectedItems.find(function (prevItem) {
            return prevItem.uniqueItemId === item.uniqueItemId;
          })) {
            if (itemIsFromPropItems) {
              return {
                selectedItems: newSelectedItems
              };
            }
            var newComputedItems = prevState.computedItems.filter(function (compi) {
              return compi.uniqueItemId !== item.uniqueItemId;
            });
            return {
              selectedItems: newSelectedItems,
              computedItems: newComputedItems
            };
          }
          return {
            selectedItems: newSelectedItems,
            computedItems: !itemIsFromPropItems ? prevState.computedItems.concat([item]) : prevState.computedItems
          };
        });
      }
      if (!!onItemSelect) {
        onItemSelect(item.uniqueItemId);
      }
      if (!!onItemSelectionsChange) {
        onItemSelectionsChange(newSelectedItems);
      }
    };
    _this.handleRemoveAllSelections = function () {
      _this.setState(function (prevState, prevProps) {
        var selectedItems = prevState.selectedItems;
        var onItemSelectionsChange = prevProps.onItemSelectionsChange,
          onRemoveAll = prevProps.onRemoveAll;
        var disabledItems = [];
        if (onRemoveAll) {
          onRemoveAll();
        }
        for (var _i = 0, selectedItems_1 = selectedItems; _i < selectedItems_1.length; _i++) {
          var item = selectedItems_1[_i];
          if (item.disabled) {
            disabledItems.push(item);
          }
        }
        if (onItemSelectionsChange) {
          onItemSelectionsChange(disabledItems);
        }
        return {
          selectedItems: disabledItems,
          computedItems: prevProps.items
        };
      });
      if (_this.filterInputRef && _this.filterInputRef.current) {
        _this.filterInputRef.current.focus();
      }
    };
    _this.filter = function (data, query) {
      return data.labelText.toLowerCase().includes(query.toLowerCase());
    };
    _this.focusInInput = function (ownerDocument) {
      return ownerDocument ? ownerDocument.activeElement === _this.filterInputRef.current : false;
    };
    _this.focusInPopover = function (ownerDocument) {
      var _a;
      return ownerDocument ? (_a = _this.popoverListRef.current) === null || _a === void 0 ? void 0 : _a.contains(ownerDocument.activeElement) : false;
    };
    _this.focusInToggleButton = function (ownerDocument) {
      var _a;
      return ownerDocument ? (_a = _this.toggleButtonRef.current) === null || _a === void 0 ? void 0 : _a.contains(ownerDocument.activeElement) : false;
    };
    _this.handleBlur = function () {
      if (!!_this.props.onBlur) {
        _this.props.onBlur();
      }
      var ownerDocument = getOwnerDocument(_this.popoverListRef);
      if (!ownerDocument) {
        return;
      }
      requestAnimationFrame(function () {
        var focusInPopover = _this.focusInPopover(ownerDocument);
        var focusInInput = _this.focusInInput(ownerDocument);
        var focusInToggleButton = _this.focusInToggleButton(ownerDocument);
        var focusInMultiSelect = focusInPopover || focusInInput || focusInToggleButton;
        var userAddedSelectedItems = _this.state.selectedItems.filter(function (si) {
          return _this.props.items.every(function (pi) {
            return pi.uniqueItemId !== si.uniqueItemId;
          });
        });
        if (!focusInMultiSelect) {
          _this.setState(function (_prevState, prevProps) {
            return {
              filterInputValue: '',
              filteredItems: prevProps.items,
              showPopover: false,
              showOptionsAvailableText: false,
              focusedDescendantId: null,
              computedItems: prevProps.items.concat(userAddedSelectedItems)
            };
          });
        }
      });
    };
    _this.handleKeyDown = function (event) {
      var _a = _this.state,
        items = _a.filteredItems,
        focusedDescendantId = _a.focusedDescendantId,
        filterInputValue = _a.filterInputValue;
      var index = !!focusedDescendantId ? items.findIndex(function (_a) {
        var uniqueItemId = _a.uniqueItemId;
        return uniqueItemId === focusedDescendantId;
      }) : null;
      var getNextIndex = function getNextIndex() {
        return index !== null ? (index + 1) % items.length : 0;
      };
      var getPreviousIndex = function getPreviousIndex() {
        return index !== null && index !== -1 ? (index - 1 + items.length) % items.length : items.length - 1;
      };
      var getNextItem = function getNextItem() {
        return items[getNextIndex()];
      };
      var getPreviousItem = function getPreviousItem() {
        return items[getPreviousIndex()];
      };
      switch (event.key) {
        case 'ArrowDown':
          {
            event.preventDefault();
            _this.setState({
              showPopover: true
            });
            var nextItem = _this.props.allowItemAddition && (index === items.length - 1 || items.length === 0) && filterInputValue !== '' && !_this.inputValueInItems() ? {
              uniqueItemId: filterInputValue.toLowerCase(),
              labelText: filterInputValue
            } : getNextItem();
            if (nextItem) {
              _this.setState({
                focusedDescendantId: nextItem.uniqueItemId
              });
            }
            break;
          }
        case 'ArrowUp':
          {
            event.preventDefault();
            _this.setState({
              showPopover: true
            });
            var previousItem = _this.props.allowItemAddition && (index === null || index === 0) && filterInputValue !== '' && !_this.inputValueInItems() ? {
              uniqueItemId: filterInputValue.toLowerCase(),
              labelText: filterInputValue
            } : getPreviousItem();
            if (previousItem) {
              _this.setState({
                focusedDescendantId: previousItem.uniqueItemId
              });
            }
            break;
          }
        case 'Enter':
          {
            event.preventDefault();
            if (focusedDescendantId) {
              var focusedItem = items.find(function (_a) {
                var uniqueItemId = _a.uniqueItemId;
                return uniqueItemId === focusedDescendantId;
              });
              if (focusedItem) {
                _this.handleItemSelection(focusedItem);
              } else {
                var userAddedItem = {
                  uniqueItemId: filterInputValue.toLowerCase(),
                  labelText: filterInputValue
                };
                _this.handleItemSelection(userAddedItem);
              }
            }
            break;
          }
        case 'Escape':
          {
            if (_this.state.showPopover) {
              event.stopPropagation();
            }
            _this.setState(function (_prevState, prevProps) {
              return {
                filterInputValue: '',
                filteredItems: prevProps.items
              };
            });
            _this.setState({
              showPopover: false,
              focusedDescendantId: null
            });
            break;
          }
      }
    };
    _this.disableItems = function (items) {
      return items.map(function (item) {
        return __assign(__assign({}, item), {
          disabled: true
        });
      });
    };
    _this.inputValueInItems = function () {
      return !!_this.state.computedItems.find(function (ci) {
        return ci.uniqueItemId === _this.state.filterInputValue.toLowerCase() || ci.labelText.toLowerCase() === _this.state.filterInputValue.toLowerCase();
      });
    };
    _this.popoverListRef = /*#__PURE__*/React.createRef();
    _this.filterInputRef = _this.props.forwardedRef ? _this.props.forwardedRef : /*#__PURE__*/React.createRef();
    _this.toggleButtonRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  BaseMultiSelect.getDerivedStateFromProps = function (nextProps, prevState) {
    var selectedItems = nextProps.selectedItems;
    if ('selectedItems' in nextProps && selectedItems !== prevState.selectedItems) {
      return {
        selectedItems: selectedItems || prevState.selectedItems || []
      };
    }
    return null;
  };
  BaseMultiSelect.prototype.componentDidUpdate = function (prevProps) {
    if (JSON.stringify(this.props.items) !== JSON.stringify(prevProps.items)) {
      this.setState({
        computedItems: this.props.items
      });
    }
  };
  BaseMultiSelect.prototype.componentWillUnmount = function () {
    if (this.chipRemovalAnnounceTimeOut) {
      clearTimeout(this.chipRemovalAnnounceTimeOut);
    }
  };
  BaseMultiSelect.prototype.clickWasInToggleButton = function (event) {
    return !!this.toggleButtonRef && this.toggleButtonRef.current.contains(event.target);
  };
  BaseMultiSelect.prototype.handleToggleButtonClick = function (event) {
    event.preventDefault();
    if (!!this.filterInputRef && this.filterInputRef.current) {
      if (document.activeElement !== this.filterInputRef.current) {
        this.filterInputRef.current.focus();
      } else {
        this.setState(function (prevState) {
          return {
            showPopover: !prevState.showPopover,
            showOptionsAvailableText: !prevState.showOptionsAvailableText
          };
        });
      }
    }
  };
  BaseMultiSelect.prototype.render = function () {
    var _a;
    var _this = this;
    var _b = this.state,
      filteredItems = _b.filteredItems,
      showPopover = _b.showPopover,
      focusedDescendantId = _b.focusedDescendantId,
      selectedItems = _b.selectedItems,
      filterInputValue = _b.filterInputValue,
      chipRemovalAnnounceText = _b.chipRemovalAnnounceText,
      computedItems = _b.computedItems;
    var _c = this.props,
      id = _c.id,
      className = _c.className,
      labelText = _c.labelText,
      optionalText = _c.optionalText,
      hintText = _c.hintText;
      _c.onItemSelectionsChange;
      var chipListVisible = _c.chipListVisible,
      ariaChipActionLabel = _c.ariaChipActionLabel,
      removeAllButtonLabel = _c.removeAllButtonLabel,
      visualPlaceholder = _c.visualPlaceholder,
      loading = _c.loading,
      loadingText = _c.loadingText,
      noItemsText = _c.noItemsText;
      _c.defaultSelectedItems;
      var propOnChange = _c.onChange,
      onChangeWithoutDebounce = _c.onChangeWithoutDebounce,
      debounce = _c.debounce,
      status = _c.status,
      statusText = _c.statusText;
      _c.selectedItems;
      _c.onItemSelect;
      _c.onRemoveAll;
      _c.onBlur;
      var ariaSelectedAmountText = _c.ariaSelectedAmountText,
      ariaSelectedAmountTextFunction = _c.ariaSelectedAmountTextFunction,
      ariaOptionsAvailableText = _c.ariaOptionsAvailableText,
      ariaOptionsAvailableTextFunction = _c.ariaOptionsAvailableTextFunction,
      ariaOptionChipRemovedText = _c.ariaOptionChipRemovedText,
      ariaOptionChipRemovedTextFunction = _c.ariaOptionChipRemovedTextFunction,
      disabled = _c.disabled,
      allowItemAddition = _c.allowItemAddition,
      itemAdditionHelpText = _c.itemAdditionHelpText,
      tooltipComponent = _c.tooltipComponent;
      _c.items;
      _c.forwardedRef;
      var listProps = _c.listProps,
      style = _c.style,
      fullWidth = _c.fullWidth,
      rest = __rest(_c, ["id", "className", "labelText", "optionalText", "hintText", "onItemSelectionsChange", "chipListVisible", "ariaChipActionLabel", "removeAllButtonLabel", "visualPlaceholder", "loading", "loadingText", "noItemsText", "defaultSelectedItems", "onChange", "onChangeWithoutDebounce", "debounce", "status", "statusText", "selectedItems", "onItemSelect", "onRemoveAll", "onBlur", "ariaSelectedAmountText", "ariaSelectedAmountTextFunction", "ariaOptionsAvailableText", "ariaOptionsAvailableTextFunction", "ariaOptionChipRemovedText", "ariaOptionChipRemovedTextFunction", "disabled", "allowItemAddition", "itemAdditionHelpText", "tooltipComponent", "items", "forwardedRef", "listProps", "style", "fullWidth"]);
    var _d = separateMarginProps(rest),
      passProps = _d[1];
    var filteredItemsWithChecked = filteredItems.map(function (item) {
      return __assign(__assign({}, item), {
        checked: !!selectedItems.find(function (selectedItem) {
          return selectedItem.uniqueItemId === item.uniqueItemId;
        })
      });
    });
    var ariaActiveDescendant = focusedDescendantId ? "".concat(id, "-").concat(focusedDescendantId) : '';
    var popoverItemListId = "".concat(id, "-popover");
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HtmlDiv, __assign({}, passProps, {
      className: classnames(baseClassName, className, (_a = {}, _a[multiSelectClassNames.open] = showPopover, _a[multiSelectClassNames.error] = status === 'error', _a["".concat(baseClassName, "--full-width")] = fullWidth, _a)),
      style: style
    }), /*#__PURE__*/React.createElement(HtmlDiv, {
      className: classnames(multiSelectClassNames.content_wrapper, {})
    }, /*#__PURE__*/React.createElement(Debounce, {
      waitFor: debounce
    }, function (debouncer) {
      return /*#__PURE__*/React.createElement(FilterInput, {
        inputElementContainerProps: {
          role: 'combobox',
          'aria-haspopup': 'listbox',
          'aria-owns': popoverItemListId,
          'aria-expanded': showPopover
        },
        "aria-activedescendant": ariaActiveDescendant,
        id: id,
        labelText: labelText,
        optionalText: optionalText,
        hintText: hintText,
        items: computedItems,
        onFilter: function onFilter(filtered) {
          _this.setState(function (prevState) {
            var newFocusedDescendandId = prevState.focusedDescendantId;
            if (!filtered.some(function (f) {
              return f.uniqueItemId === newFocusedDescendandId;
            })) {
              newFocusedDescendandId = null;
            }
            return {
              filteredItems: filtered,
              focusedDescendantId: newFocusedDescendandId
            };
          });
        },
        filterFunc: _this.filter,
        forwardedRef: _this.filterInputRef,
        onFocus: function onFocus() {
          return _this.setState({
            showPopover: true,
            showOptionsAvailableText: true
          });
        },
        onKeyDown: _this.handleKeyDown,
        onBlur: _this.handleBlur,
        value: filterInputValue,
        onChange: function onChange(value) {
          if (propOnChange) {
            debouncer(propOnChange, value);
          }
          if (onChangeWithoutDebounce) {
            onChangeWithoutDebounce(value);
          }
          _this.setState({
            filterInputValue: value,
            showPopover: true
          });
        },
        visualPlaceholder: visualPlaceholder,
        status: status,
        statusText: statusText,
        "aria-controls": popoverItemListId,
        disabled: disabled,
        tooltipComponent: tooltipComponent
      }, /*#__PURE__*/React.createElement(InputToggleButton, {
        open: showPopover,
        ref: _this.toggleButtonRef,
        onClick: function onClick(event) {
          return _this.handleToggleButtonClick(event);
        },
        "aria-hidden": true,
        tabIndex: -1,
        disabled: disabled
      }));
    }), showPopover && ( /*#__PURE__*/React.createElement(Popover, {
      sourceRef: this.filterInputRef,
      matchWidth: true,
      onKeyDown: this.handleKeyDown,
      onClickOutside: function onClickOutside(event) {
        if (!_this.clickWasInToggleButton(event)) {
          _this.setState({
            showPopover: false
          });
        }
      }
    }, /*#__PURE__*/React.createElement(PopoverConsumer, null, function (consumer) {
      return /*#__PURE__*/React.createElement(SelectItemList, __assign({
        id: popoverItemListId,
        ref: _this.popoverListRef,
        focusedDescendantId: ariaActiveDescendant,
        "aria-multiselectable": "true"
      }, listProps), /*#__PURE__*/React.createElement(React.Fragment, null, !loading && filteredItemsWithChecked.length > 0 && filteredItemsWithChecked.map(function (item) {
        var _a;
        var isCurrentlySelected = item.uniqueItemId === focusedDescendantId;
        return /*#__PURE__*/React.createElement(SelectItem, __assign({
          hasKeyboardFocus: isCurrentlySelected,
          key: "".concat(item.uniqueItemId, "_").concat(item.checked),
          id: "".concat(id, "-").concat(item.uniqueItemId),
          checked: item.checked,
          disabled: item.disabled,
          onClick: function onClick() {
            _this.handleItemSelection(item);
            consumer.updatePopover();
          },
          hightlightQuery: (_a = _this.filterInputRef.current) === null || _a === void 0 ? void 0 : _a.value
        }, item.listItemProps), item.labelText);
      }), !loading && filteredItemsWithChecked.length === 0 && !allowItemAddition && ( /*#__PURE__*/React.createElement(SelectEmptyItem, null, noItemsText)), !loading && filterInputValue !== '' && !_this.inputValueInItems() && allowItemAddition && ( /*#__PURE__*/React.createElement(SelectItemAddition, {
        hintText: itemAdditionHelpText,
        hasKeyboardFocus: filterInputValue === focusedDescendantId,
        id: "".concat(id, "-").concat(filterInputValue.toLowerCase()),
        onClick: function onClick() {
          var item = {
            labelText: filterInputValue,
            uniqueItemId: filterInputValue.toLowerCase()
          };
          _this.handleItemSelection(item);
          _this.setState({
            focusedDescendantId: filterInputValue.toLowerCase()
          });
        }
      }, filterInputValue)), loading && ( /*#__PURE__*/React.createElement(SelectEmptyItem, {
        className: "loading"
      }, /*#__PURE__*/React.createElement(LoadingSpinner, {
        status: "loading",
        variant: "small",
        textAlign: "right",
        text: loadingText
      })))));
    }))), chipListVisible && ( /*#__PURE__*/React.createElement(MultiSelectChipList, {
      sourceRef: this.filterInputRef,
      selectedItems: disabled ? this.disableItems(selectedItems) : selectedItems,
      ariaChipActionLabel: ariaChipActionLabel,
      onClick: function onClick(item) {
        if (!!_this.chipRemovalAnnounceTimeOut) {
          clearTimeout(_this.chipRemovalAnnounceTimeOut);
        }
        _this.chipRemovalAnnounceTimeOut = setTimeout(function () {
          _this.setState({
            chipRemovalAnnounceText: ''
          });
        }, 1000);
        if (ariaOptionChipRemovedTextFunction) {
          _this.setState({
            chipRemovalAnnounceText: ariaOptionChipRemovedTextFunction(item.chipText ? item.chipText : item.labelText)
          });
        } else {
          _this.setState({
            chipRemovalAnnounceText: "".concat(item.chipText ? item.chipText : item.labelText, " ").concat(ariaOptionChipRemovedText)
          });
        }
        _this.handleItemSelection(item);
      }
    })), /*#__PURE__*/React.createElement(MultiSelectRemoveAllButton, {
      className: multiSelectClassNames.removeAllButton,
      selectedItems: disabled ? this.disableItems(selectedItems) : selectedItems,
      onClick: this.handleRemoveAllSelections
    }, removeAllButtonLabel))), /*#__PURE__*/React.createElement(VisuallyHidden, {
      "aria-live": "polite",
      "aria-atomic": "true"
    }, this.state.showOptionsAvailableText ? ariaSelectedAmountTextFunction ? ( /*#__PURE__*/React.createElement(React.Fragment, null, ariaSelectedAmountTextFunction(selectedItems.length))) : ( /*#__PURE__*/React.createElement(React.Fragment, null, selectedItems.length, ariaSelectedAmountText)) : ''), /*#__PURE__*/React.createElement(VisuallyHidden, {
      "aria-live": "polite",
      "aria-atomic": "true",
      id: "".concat(id, "-filteredItems-length")
    }, !loading && this.state.showOptionsAvailableText ? this.focusInInput(getOwnerDocument(this.popoverListRef)) ? ariaOptionsAvailableTextFunction ? ( /*#__PURE__*/React.createElement(React.Fragment, null, ariaOptionsAvailableTextFunction(filteredItems.length))) : ( /*#__PURE__*/React.createElement(React.Fragment, null, filteredItems.length, ariaOptionsAvailableText)) : '' : ''), /*#__PURE__*/React.createElement(VisuallyHidden, {
      "aria-live": "polite",
      "aria-atomic": "true",
      id: "".concat(id, "-loading-announce")
    }, loading ? loadingText : ''), /*#__PURE__*/React.createElement(VisuallyHidden, {
      "aria-live": "assertive",
      "aria-atomic": "true",
      id: "".concat(id, "-chip-removal-announce")
    }, chipRemovalAnnounceText));
  };
  return BaseMultiSelect;
}(Component);
var StyledMultiSelect = styled(function (_a) {
  _a.theme;
    _a.globalMargins;
    var passProps = __rest(_a, ["theme", "globalMargins"]);
  return /*#__PURE__*/React.createElement(BaseMultiSelect, __assign({}, passProps));
}).withConfig({
  componentId: "sc-xk35df-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    globalMargins = _a.globalMargins,
    rest = __rest(_a, ["theme", "globalMargins"]);
  var _b = separateMarginProps(rest),
    marginProps = _b[0];
  var cleanedGlobalMargins = filterDuplicateKeys(globalMargins === null || globalMargins === void 0 ? void 0 : globalMargins.multiSelect, marginProps);
  return baseStyles(theme, cleanedGlobalMargins, marginProps);
});
function MultiSelectInner(props, ref) {
  var propId = props.id,
    passProps = __rest(props, ["id"]);
  return /*#__PURE__*/React.createElement(SpacingConsumer, null, function (_a) {
    var margins = _a.margins;
    return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
      var suomifiTheme = _a.suomifiTheme;
      return /*#__PURE__*/React.createElement(AutoId, {
        id: propId
      }, function (id) {
        return /*#__PURE__*/React.createElement(StyledMultiSelect, __assign({
          theme: suomifiTheme,
          id: id,
          forwardedRef: ref,
          globalMargins: margins
        }, passProps));
      });
    });
  });
}
var MultiSelect = /*#__PURE__*/forwardRef(MultiSelectInner);
MultiSelect.displayName = 'MultiSelect';
var templateObject_1;

export { MultiSelect };
//# sourceMappingURL=MultiSelect.js.map
